// extracted by mini-css-extract-plugin
export default {"wrap":"pp-z","logoContainer":"qp-z","brandImg":"rp-z","logoImg":"sp-z","logoButton":"tp-z"};